import { Component } from '@angular/core';

@Component({
    selector: 'app-view-validation',
    imports: [],
    templateUrl: './view-validation.component.html',
    styleUrl: './view-validation.component.scss'
})
export class ViewValidationComponent {

}
